import apiUseCases from "../api";
import store from "@src/reducers/store";

export interface GetTimeseriesDataResult {
  success: boolean;
  data?: unknown;
  error?: string;
  status?: number;
}

export interface GetTimeseriesDataUseCaseParams {
  group: string;
  source: string;
  days?: number;
  to?: string;
  from?: string;
  frequency?:
    | "raw"
    | "quarterhourly"
    | "hourly"
    | "daily"
    | "weekly"
    | "monthly"
    | "yearly";
  sortorder?: "ASC" | "DESC";
  limit?: number;
  limit_order?: "ASC" | "DESC";
  show_missing?: boolean;
}

export const getQueryTimeseriesForNodeUseCase = async ({
  group,
  source,
  days,
  from,
  to,
  frequency,
  sortorder,
  limit,
  limit_order,
  show_missing,
}: GetTimeseriesDataUseCaseParams): Promise<GetTimeseriesDataResult> => {
  const namespace = store.getState().yourSlice.authContext.customerNamespace;

  const response = await apiUseCases.getQueryTimeseriesForNodeAPI({
    namespace,
    group,
    source,
    days,
    from,
    to,
    frequency,
    sortorder,
    limit,
    limit_order,
    show_missing,
  });

  if (!response.success) {
    return {
      success: false,
      error: response.error,
      status: response.status,
    };
  }

  return {
    success: true,
    data: response.data,
  };
};
